<template>
  <div class="modal-container">
    <div v-if="isOpen" @click.self="close" class="modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" class="close" v-on:click="close">
              <span>&times;</span>
            </button>
          </div>

          <div v-if="type === 'error'" class="modal-error">{{ text }}</div>

          <div v-if="type == 'confirm'">
            <div class="modal-body">
              {{ text }}
            </div>
            <div class="modal-footer">
              <button @click="close" type="button" class="btn btn-secondary">
                {{ $t("modal.cancel") }}
              </button>
              <button
                :disabled="loading"
                @click="confirm"
                type="button"
                class="btn btn-primary action"
              >
                <template v-if="!loading">{{ $t("modal.confirm") }}</template>
                <template v-else>
                  <div class="spinner-border spinner-border-sm"></div>
                </template>
              </button>
            </div>
          </div>

          <div v-if="type == 'error'">
            <div class="modal-footer">
              <button @click="close" type="button" class="btn btn-secondary">
                {{ $t("modal.ok") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue from "vue";
import { mapGetters } from "vuex";
export default {
  props: ["loading"],
  mounted: function () {
    this.$modalEvent.$on("openModal", ({ type, title, callback, text }) => {
      this.title = title;
      this.type = type;
      this.text = text || "";
      this.callback = callback;
      this.isOpen = true;
    });
    this.$modalEvent.$on("modalError", ({ type, title, callback, text }) => {
      if (title) {
        this.title = title;
      }
      if (callback) {
        this.callback = callback;
      }
      if (type) {
        this.type = type;
      }
      if (text) {
        this.text = text;
      }
      this.isOpen = true;
    });

    this.$modalEvent.$on("closeModal", () => {
      this.isOpen = false;
    });
  },
  methods: {
    close: function () {
      this.isOpen = false;
    },
    save: function () {
      this.callback(this.value);
    },
    confirm: function () {
      this.callback(true);
    },
  },
  data() {
    return {
      value: "",
      isOpen: false,
      modals: [],
      title: "",
      type: "",
      text: "",
      callback: null,
    };
  },
};
</script>

<style scoped>
.action {
  width: 6rem;
}
.modal-error {
  color: red;
  font-weight: bold;
}
.modal-title {
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 4; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  color: #0B0B14;
}

.modal-content {
  background-color: #fefefe;
  margin: 20% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  max-width: 650px; /* Could be more or less, depending on screen size */
  box-shadow: 5px 5px 15px hsla(0, 0%, 0%, 0.4);
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.modal-select > input[type="modal"] {
  display: none;
}

@media screen and (max-width: 768px) {
  .modal-content {
    width: 100%;
    margin: 15% auto;
  }
}
</style>
